import axios from "axios";
import { STUDIES_BASE_PATH } from "../resources/ApiUrls";
import { LocalStorageManager } from "./LocalStorageManager";
import { authConstants } from "constants/authConstants";

const fetchClient = () => {
  const defaultOptions = {
    baseURL: STUDIES_BASE_PATH,
    headers: {
      "Content-Type": "application/json",
    },
  };

  // CREATE INSTANCE
  let instance = axios.create(defaultOptions);

  instance.interceptors.request.use((config) => {
    const token = LocalStorageManager.getLocalStorageItem(authConstants.MonitoringUserNew)?.tokens.studiesToken

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config;
  });
  return instance;
};

export default fetchClient();
